import { useNavigate } from "react-router-dom";
import { useModalGac } from "./hook/useModalGac";
import CustomModal from "./modal/CustomModal";

const UserMora = ({ text, mmora }) => {
  const [isOpenModal, , closeModal] = useModalGac(true);

  const navigate = useNavigate();

  const moraMessage = mmora || text || "";
  const moraMessageLower = moraMessage.toLowerCase().trim();

  // Detectar solo cuando es por saldo de derechos de afiliación
  const isAffiliationDebt = moraMessageLower.includes("gastos legales");

  const handleNavigation = (section) => {
    navigate("/home", { replace: true });
    setTimeout(() => {
      document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
    }, 100);
    closeModal();
  };

  return (
    <CustomModal isOpen={isOpenModal}>
      <div className="card-mora">
        {isAffiliationDebt ? (
          <h3 className="text-center">
            Tu plan Vacacional Presenta saldo en tus derechos de afiliación
            complétalos y disfruta los beneficios del portal auto-gestión
          </h3>
        ) : (
          <h3 className="text-center">
            Tu plan vacacional presenta mora {moraMessage.slice(38)}
          </h3>
        )}

        <a
          target="_blank"
          className="centrar text-white m-3"
          href="https://wa.link/ar2rk4"
          rel="noopener noreferrer"
          style={{ textDecoration: "underline" }}
        >
          <img
            src="/images/icono-de-whatsapp.png"
            alt="img_WhatsApp"
            style={{ width: "20px" }}
          />
          <p>Si deseas contactar tu agente de cuenta</p>
        </a>
        <div className="modal-footer centrar">
          <button
            onClick={() => handleNavigation("placeOrder")}
            className="col-sm-12 col-md-12 col-lg-5 col-xl-5 btn-payU"
          >
            <span>
              <img
                src="/icons/card_pay.svg"
                alt="img mercado de pago"
                width={38}
                style={{ marginRight: "10px" }}
              />
              Realiza tú Pago
            </span>
          </button>
        </div>
      </div>
    </CustomModal>
  );
};

export default UserMora;
